/** @enum number */
const Status = Object.freeze({
  /** @type {0} */ LOADING: 0,
  /** @type {1} */ SUCCESS: 1,
  /** @type {2} */ WARNING: 2,
  /** @type {3} */ ERROR: 3,
  /** @type {4} */ INFO: 4,
})

export default Status
